import { z } from "zod";

import payers from "@/src/data/payers.json";
import codebookJson from "@/src/lib/ehr/athena/data/athena-payer-codebook.json";
import { logAndThrow } from "@/src/lib/logging/logger";

export const ATHENA_PAYER_CODE = /^[A-Z][A-Z0-9_]*$/;

const catalogPrimaryPayerIds = new Set(
  (payers as { primaryPayerId?: string | null }[])
    .map((payer) => payer.primaryPayerId?.trim())
    .filter((id): id is string => Boolean(id))
);

export function requireCatalogPayerCodes(codes: Record<string, string>): Record<string, string> {
  const unknown = Object.entries(codes).filter(([, id]) => !catalogPrimaryPayerIds.has(id));

  if (unknown.length > 0) {
    return logAndThrow("Athena payer codes are not catalog primaryPayerIds", {
      codes: unknown.map(([code]) => code),
    });
  }

  return codes;
}

const athenaPayerCodebook: Record<string, string> = requireCatalogPayerCodes(
  z.record(z.string(), z.string()).parse(codebookJson)
);

export function mergeAthenaPayerCodes(tenant: Record<string, string>): Record<string, string> {
  return { ...athenaPayerCodebook, ...tenant };
}
